import { getEnvVariable } from '../services/utilityService';

const COUNTRY_BY_CURRENCY = {
    NGN: 'Nigeria',
    EGP: 'Egypt',
    XOF: "Cote d'Ivoire",
    CFA: 'Senegal',
};

export const appConfig = {
    languageOption: getEnvVariable('REACT_APP_FEATURE_LANGUAGE_OPTION'),
    countryCurrency: getEnvVariable('REACT_APP_COUNTRY_CURRENCY'),
    supportedLocales: getEnvVariable('REACT_APP_SUPPORTED_LOCALES'),
    supportEmailAddress: getEnvVariable('REACT_APP_EMAIL_ADDRESS'),
    supportPhoneNumber: getEnvVariable('REACT_APP_PHONE_NUMBER'),
    benefitsUrl: getEnvVariable('REACT_APP_BENEFITS_URL'),
    helpEmailAddress: getEnvVariable('REACT_APP_EMAIL_ADDRESS'),
    companyName: getEnvVariable('REACT_APP_COMPANY_NAME'),
    logoName: getEnvVariable('REACT_APP_LOGO_NAME'),
    reportBaseUrl: getEnvVariable('REACT_APP_REPORT_BASE_URL'),
    daaraServiceBaseUrl: getEnvVariable('REACT_APP_DAARA_SERVICE_BASE_URL'),
    metaBase: getEnvVariable('REACT_APP_META_BASE_ENABLED') === 'true',
    requestsEnabled: getEnvVariable('REACT_APP_REQUESTS_ENABLED') === 'true',
    policiesEnabled: getEnvVariable('REACT_APP_POLICIES_ENABLED') === 'true',
    // Read directly from process.env (not getEnvVariable) so a missing var
    // degrades to the Requests page's error UI instead of crashing app boot.
    requestsProxyBaseUrl: process.env.REACT_APP_REQUESTS_PROXY_URL,
    monolithBaseUrl: new URL(getEnvVariable('REACT_APP_BASE_API_URL')).host,
    country: COUNTRY_BY_CURRENCY[getEnvVariable('REACT_APP_COUNTRY_CURRENCY')]
};
